<template>
  <SectionPageShell section="ads" title="Werbeanzeige anlegen" show-back-link>
    <AdForm @submitted="createAd" />
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import {useAdsStore} from "@/stores/ads";
import AdForm from "@/pages/ads/Form.vue";

export default {
  components: {
    AdForm,
    SectionPageShell,
  },
  setup() {
    return {
      adStore: useAdsStore(),
    }
  },
  methods: {
    createAd(values) {
      this.adStore.create(values)
    },
  },
}
</script>
